exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v3-dialog-title{border-bottom:1px solid #ccc;display:flex;height:60px;width:100%;align-items:center;justify-content:space-between;padding:15px 20px 15px 30px}.v3-dialog-title-text{font-size:18px;line-height:1.22;font-weight:500;line-height:26px;--tw-text-opacity:1;color:rgba(51, 51, 51, var(--tw-text-opacity))}.v3-dialog-title-icons{height:25px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader/lib!./src/componentsv3/Dialog/components/DialogHeader/style.css
 ** module id = 1196
 ** module chunks = 0
 **/